module.exports = __webpack_public_path__ + "img/R.6d73f605.png";